import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";

const values = [
  { n: "01", t: "Personal connection", b: "We prioritize real conversations. We're your partners, not just your vendors." },
  { n: "02", t: "People-oriented tech", b: "Complex technology should feel effortless to the people who use it every day." },
  { n: "03", t: "Radical honesty", b: "If an AI solution isn't right for you or won't yield a good return, we'll tell you." },
  { n: "04", t: "Accuracy over everything", b: "In business-critical workflows, 'close enough' is a failure." },
  { n: "05", t: "Absolute respect for data", b: "We treat your proprietary information as a vault for your digital assets." },
];

export default function CoreValues() {
  return (
    <section className="bg-navy text-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <Eyebrow tone="teal">Core Values</Eyebrow>
          <h2 className="mt-6 font-extrabold tracking-tightish" style={{ fontSize: "clamp(30px,4vw,46px)" }}>
            How we work is just as important as{" "}
            <span className="font-display italic font-medium text-teal">what we build</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-0 border-t border-white/10">
          {values.map((v, i) => (
            <Reveal
              key={v.n}
              delay={i * 80}
              className={`p-7 lg:p-8 border-white/10 ${
                i !== 0 ? "lg:border-l" : ""
              } ${i < values.length - 1 ? "border-b sm:border-b lg:border-b-0" : ""}`}
            >
              <div className="font-display italic text-teal" style={{ fontSize: "44px", fontWeight: 500 }}>
                {v.n}
              </div>
              <h3 className="mt-5 text-[17px] font-bold">{v.t}</h3>
              <p className="mt-3 text-mist/75 text-[14px] leading-relaxed">{v.b}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
